import { createContext, useContext } from 'react';

import type { TabsLayout, TabsMode } from './types';

type TabsContextValue = {
  mode: TabsMode;
  layout: TabsLayout;
  /** Navigation only: the location each `TabLink` compares its `href` with. */
  pathname?: string;
};

export const TabsContext = createContext<TabsContextValue | null>(null);

export const useTabsContext = (part: string) => {
  const context = useContext(TabsContext);

  if (!context) {
    throw new Error(`${part} must be rendered inside <Tabs>.`);
  }

  return context;
};
